export default __webpack_public_path__ + "static/media/hotel-hidrogeno.3626f1ef.jpg";